module.exports = __webpack_public_path__ + "img/tzav_yes.eec7ab2c.png";